/**
 * useInspiration — React Query hooks dla pipeline inspiration API.
 */
import { useMutation } from "@tanstack/react-query";
import { apiRequest, queryClient } from "@/lib/queryClient";

export interface AddLinkInput {
  agencyClientId?: string | null;
  url: string;
  platform?: string;
  notes?: string;
  autopilotSessionId?: string;
}

export interface AddScreenshotInput {
  agencyClientId?: string | null;
  screenshotUrl: string;
  variationCount: number;
  targetFormat: "image" | "video";
  preserveAspects?: string[];
  adaptAspects?: string[];
  notes?: string;
  autopilotSessionId?: string;
}

export function useAddLinkInspiration() {
  return useMutation({
    mutationFn: (input: AddLinkInput) =>
      apiRequest("POST", "/api/creative-pipeline/inspiration/link", input),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["creative-pipeline"] }),
  });
}

export function useAddScreenshotInspiration() {
  return useMutation({
    mutationFn: (input: AddScreenshotInput) =>
      apiRequest("POST", "/api/creative-pipeline/inspiration/screenshot", input),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["creative-pipeline"] }),
  });
}

export function usePresignInspirationUpload() {
  return useMutation({
    mutationFn: (input: { filename: string; mimeType: string }) =>
      apiRequest("POST", "/api/creative-pipeline/inspiration/presign-upload", input).then(
        (r) => r.json() as Promise<{ uploadUrl: string; getUrl: string; key: string }>
      ),
  });
}
